export default {
  namespaced: true,
  state: {
    queston_type: {
      SCQ: 1, // 单选
      MCQ: 2, // 多选
      SBQ: 3, // 填空
      MBQ: 4, // 多项填空
      DLQ: 5, // 下拉
      NPS: 6, // NPS
      VOTE: 7, // 投票
      SORT: 8, // 排序
      REMARK: 9, // 备注
      SCORE: 10, // 分数评定
      QA: 11, // 问答
      WRQ: 12, // 权重评分
      SRQ: 13, // 评星
      NAME: 14, // 姓名
      GENDER: 15, // 性别
      AGE: 16, // 年龄
      TEL: 17, // 电话号
      EMAIL: 18, // 邮箱
      DATE: 19, // 日期
      TIME: 20, // 时间
      ADDR: 21, // 地址
      TFQ: 22, // 判断题
      IMAGE: 23, // 图片
      MaxDiff: 24, // MaxDiff题
      UploadFile: 25, // 上传文件
      DownloadFile: 26, // 下载附件
      CASCADER: 27, // 联极题
      ClozeTest: 28, // 完形填空
      BDQ: 29, // 出生日期
      IDQ: 30, // 身份证号
      ELQ: 31, // 学历
      WX: 32, // 微信号
    },
  },
  getters: {
    getQuestionType: (state) => state.queston_type,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/question.js